import { continueInRovoChat } from '@atlaskit/editor-common/keymaps';
import { ChatIcon } from '../assets/icons/chat';
import { messages } from './messages';
export var createContinueInChat = function createContinueInChat(_ref) {
  var appearance = _ref.appearance,
    agent = _ref.agent,
    product = _ref.product,
    actionSideEffect = _ref.actionSideEffect,
    actionOverride = _ref.actionOverride;
  return {
    type: 'agent',
    title: messages.continueInChatLabel,
    shortcut: continueInRovoChat,
    appearance: appearance,
    run: function run(_ref2) {
      var channelId = _ref2.channelId,
        publish = _ref2.publish;
      if (!channelId || !publish) {
        return;
      }
      if (typeof actionOverride === 'function') {
        actionOverride({
          channelId: channelId
        });
        return;
      }
      publish({
        type: 'chat-open',
        product: product,
        data: {
          channelId: channelId,
          agentId: agent.namedId
        },
        source: 'editor'
      });
      actionSideEffect === null || actionSideEffect === void 0 || actionSideEffect();
    },
    preserveEditorSelectionOnComplete: true,
    icon: ChatIcon
  };
};